/**
 * 企業IDを受け取ってフォロー/アンフォローを非同期で通信
 */
import axios from 'axios';

const FOLLOWING_URL = '/api/media_receive_edit.php';

/**
 * 企業をフォローする
 *
 * @param {string} companyId 企業ID
 */
export function postFollowing (companyId) {
  return toggleFollowing(companyId, 'false');
}

/**
 * 企業のフォローを外す
 *
 * @param {string} companyId 企業ID
 */
export function postUnfollowing (companyId) {
  return toggleFollowing(companyId, 'true');
}

function toggleFollowing (companyId, chk) {
  const csrfToken = document.querySelector('input[name="csrf_token"]').value;
  const params = { type: 'companyReceive', company_id: companyId, chk, csrf_token: csrfToken };
  const formData = new FormData();
  Object.entries(params).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return axios.post(FOLLOWING_URL, formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    if (Number(res.data.status) === 200) {
      return res;
    } else {
      return false;
    }
  }).catch(err => {
    throw err;
  });
}
